import { Component, Inject, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators} from "@angular/forms";

import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

import { MessageService } from 'src/services/message.service';
import { NotificationsService } from  '../../../services/notifications.service';

@Component({
  selector: 'rm-add-segment-dialog',
  templateUrl: './add-segment-dialog.component.html',
  styleUrls: ['./add-segment-dialog.component.css']
})
export class AddSegmentDialogComponent implements OnInit {

  values: any;
  message: any;
  segmentForm: FormGroup;
  userList: any[];
  selectedUsersList = [];
  isReadOnly: boolean = false;
  // checkedIDs = [];
  // checked = false;
  // indeterminate = false;
  // labelPosition: 'before' | 'after' = 'after';
  // disabled = false;
  // getUserlist: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AddSegmentDialogComponent>,
    private notificationsService: NotificationsService,
    private msgService:MessageService
  ) {}

  ngOnInit() {
  
    this.segmentForm = new FormGroup({
      name: new FormControl("", Validators.required),
      description: new FormControl()
    });
  }

  addSegment(segmentToAdd) {
    segmentToAdd.userList = this.selectedUsersList;
    // console.log(segmentToAdd);
    this.notificationsService.addSegment(segmentToAdd).subscribe(
      (response: any) => {
        this.dialogRef.close('updated');
        this.msgService.showSuccess(this.msgService.segmentCreate);
      }, err => {
        console.error("add segment server error");
      }
    );
  }

  cancel(){
    this.dialogRef.close();
  }

}